enum TipoKitEmbalagemItem {
    Volume = 1,
    Unitario = 2,
}

export default TipoKitEmbalagemItem;
